import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { NgOtpInputConfig } from 'ng-otp-input';
import { Observable } from 'rxjs';
import { GenericApiResponseModel } from '@core/generic-api/data-access';
import { IConfig } from 'ngx-mask';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';

type Prettify<T> = {
  [K in keyof T]: T[K];
} & Record<string, any>;

type _PortalFieldProps = FormlyFieldProps &
  FormlyFieldSelectProps & {
    alwaysShowHint?: boolean;
    alwaysShowMandatoryMarker?: boolean;
    color?: 'primary' | 'accent' | 'warn';
    transform?: (value: any) => any;
    displayWith?: (value: any) => any;
    autocomplete?: string[];
    hideLabel?: boolean;
    searchable?: boolean;
    clearable?: boolean;
    highlightSelected?: boolean;
    hideMandatoryMarker?: boolean;
    hint?: string;
    labelCheckbox?: string;
    labelPosition?: 'before' | 'after';
    otpConfig?: NgOtpInputConfig;
    maskConfig?: { mask: string; config?: Partial<IConfig> };
    excludeOtherOption?: boolean;
    wrapperClass?: string | string[];
    prefix?: string;
    suffix?: string;
    tooltip?: string;
    requiredTrue?: boolean;
    pagingOptions?: Observable<GenericApiResponseModel<any>>;
    multiple?: boolean;
    confirmBeforeChange?: PortalConfirmBeforeChange;
    acceptMimeTypes?: string[];
    cyTest?: string | number;
    maxDate?: Date;
    minDate?: Date;
    range?: { min: number; max: number };
    add?(i?: number, initialModel?: any, { markAsDirty }?: { markAsDirty: boolean }): void;
    remove?(i: number, { markAsDirty }?: { markAsDirty: boolean }): void;

    // NOTE: Additional properties are allowed here to support custom field types.
    // [additionalProperties: string]: any;
  };

type _PortalFieldConfig<Props = _PortalFieldProps> = FormlyFieldConfig<Props>;

interface _PortalFieldTypeConfig<T = _PortalFieldConfig['props']> extends _PortalFieldConfig<T> {
  formControl: FormControl;
  props: NonNullable<T>;
}

export type PortalFieldConfig = Prettify<_PortalFieldConfig>;
export type PortalFieldTypeConfig = Prettify<_PortalFieldTypeConfig>;
export type PortalConfirmBeforeChangeFn = (value?: unknown) => Observable<boolean>;
export type PortalConfirmBeforeChange = PortalConfirmBeforeChangeFn | boolean;
export type PortalValidatorFn<T> = (control: AbstractControl, field: PortalFieldConfig, options?: Record<string, unknown>) => T; // extends from FormlyValidatorFn
